import { ProductOP, CombinationOP } from '@cemex-core/cmx-api';
import {
  OrderBuilderActions,
  RESET_BUILDER,
} from '@ordersnproducts/modules/order-builder/actions/order-builder.actions';
import {
  ProductsActions,
  ProductsActionTypes,
} from '@ordersnproducts/modules/order-builder/modules/rms-specification/actions/open-platform/products.actions';

/**
 * The store's array of products available to the customer. (Probably in the context of a given jobsite, but this is
 * not explicitly stated.)
 */
export interface ProductsState {
  loading: boolean;
  availableProducts: ProductOP[];
  valueAddedsNotCombinable: CombinationOP[];
}

/**
 * The initial state of the product-list:  Not loading and empty.
 * @type {{availableProducts: any[]; loading: boolean}}
 */
export const initialState: ProductsState = {
  loading: false,
  availableProducts: [],
  valueAddedsNotCombinable: [],
};

/**
 * Updates the state of the product-list in the specification step of the one-click order workflow.
 * @param {ProductsState} state
 * @param {ProductsActions | OrderBuilderActions} action
 * @return {ProductsState}
 */
export function productsReducer(state = initialState, action: ProductsActions | OrderBuilderActions): ProductsState {
  switch (action.type) {
    case ProductsActionTypes.LOAD: {
      return {
        ...state,
        loading: true,
      } as ProductsState;
    }
    case ProductsActionTypes.LOAD_COMPLETE: {
      return {
        ...state,
        loading: false,
        availableProducts: action.payload.products,
        valueAddedsNotCombinable: action.payload.combinations,
      } as ProductsState;
    }
    case ProductsActionTypes.PCM_SELECT_PRODUCT: {
      return {
        ...state,
        loading: false,
        availableProducts: [...state.availableProducts, action.payload],
      } as ProductsState;
    }
    case RESET_BUILDER:
    case ProductsActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
